import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import './overview-text.styles.scss';

export default function OverviewText({ title, children }) {
  return (
    <div id='overview-text-container'>
      <Typography component='h2' variant='h5'>
        {title}
      </Typography>

      {children}
    </div>
  );
}

OverviewText.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
};
